import { usePartner } from '@/context/PartnerContext'
import { Box, Text } from '@chakra-ui/react'
import { faLock } from '@fortawesome/pro-light-svg-icons'
import { AuthPageLayout } from 'BrokerTsLib/src/components'

export const EmailLogoutPage = () => {
  const { currentPartner } = usePartner()

  return (
    <AuthPageLayout
      title="Byli jste odhlášeni."
      titleIcon={faLock}
      logo={currentPartner?.logo}
    >
      <Box maxW={'45ch'} mx={'auto'}>
        <Text fontSize={'xl'} textAlign={'center'}>
          Pro opětovné zobrazení dokumentů prosím použijte původní odkaz ze zprávy.
        </Text>
      </Box>
    </AuthPageLayout>
  )
}
